export enum FamilyTypes {
	BLK = 'BLK',
	CMS = 'CMS',
	ALL = 'ALL'
}
